module.exports = __webpack_public_path__ + "img/image10.9900f8af.png";